export { default as mailchimp } from './mailchimp.svg';
export { default as cvsHealth } from './cvs-health.svg';
export { default as ibm } from './ibm.svg';
export { default as ebay } from './ebay.svg';
export { default as google } from './google.svg';
export { default as chime } from './chime.svg';
